import { Provider } from "react-redux";
import store from "./state/store";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./style/customTheme";
import PageHeader from "./components/PageHeader/PageHeader";
import ContentArea from "./components/ContentArea/ContentArea";
import { Box } from "@mui/system";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";

function App() {
  return (
    <>
      {/* Provider for redux state information */}
      <Provider store={store}>
        {/* provider for mui theme */}
        <ThemeProvider theme={theme}>
          {/* provider for mui-x date localization */}
          <LocalizationProvider
            dateAdapter={CustomLuxonAdapter}
            adapterLocale="en-us"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
              }}
            >
              <PageHeader title="Surrey Schools Workshop Administration" />
              <ContentArea />
            </Box>
          </LocalizationProvider>
        </ThemeProvider>
      </Provider>
    </>
  );
}

export default App;

//the below CustomLuxonAdapter allows sunday to be the first day of the week
export class CustomLuxonAdapter extends AdapterLuxon {
  /** Set the order of the labels in a week. */
  getWeekdays = () => {
    return ["S", "M", "T", "W", "T", "F", "S"];
  };

  /** Generate the dates per month. */
  getWeekArray = (initial) => {
    const monthStart = initial.startOf("month").startOf("week");
    const monthEnd = initial.endOf("month").endOf("week");
    const range = monthStart.diff(monthEnd);

    const weeks = Math.round(Math.abs(range.as("weeks"))) + 1;
    const days = weeks * 7;

    const month = [];

    for (let index = 0; index < days; index++) {
      const week = month.length - 1;

      const date = initial
        .startOf("month")
        .startOf("week")
        .plus({ day: index - 1 });

      if (index === 0 || index % 7 === 0) {
        month.push([date]);
        continue;
      }

      month[week] = [...month[week], date];
    }

    return month;
  };
}
